// ----------------------------------------------------------------------

export const PATH_KYC = {
  root: "/kyc",
};
